import { render, staticRenderFns } from "./retailDetail.vue?vue&type=template&id=e1b7f726&scoped=true&"
import script from "./retailDetail.vue?vue&type=script&lang=js&"
export * from "./retailDetail.vue?vue&type=script&lang=js&"
import style0 from "./retailDetail.vue?vue&type=style&index=0&id=e1b7f726&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b7f726",
  null
  
)

export default component.exports